import { createContext, useContext } from 'react';

const FormContext = createContext<any>(undefined);

export const useFormContext = () => useContext(FormContext);
export default FormContext;
